<!--
    描述：版本信息列表
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-table-layout w-table-page">
        <transition name="fade" mode="out-in">
            <!-- 列表 -->
            <div class="list-wrap w-table-content" ref="tableContent" key="list">
                <el-table :data="tableObj.tableData"
                          row-key="id"
                          v-loading="tableObj.loading"
                          ref="tableObj"
                          default-expand-all
                          :height="tableObj.tableH"
                          border
                          highlight-current-row>
                    <el-table-column type="index" align="center" width="50"></el-table-column>
                    <el-table-column prop="title" label="标题" header-align="center" show-overflow-tooltip width="230"></el-table-column>
                    <el-table-column prop="versionNum" label="版本号" header-align="center" align="right" show-overflow-tooltip width="95"></el-table-column>
                    <el-table-column prop="content" label="内容" header-align="center" show-overflow-tooltip min-width="200">
                        <!-- 不转换，内容换行，显示不美观
                        <template slot-scope="scope">
                            <div v-html="scope.row.content"></div>
                        </template>
                        -->
                    </el-table-column>
                    <el-table-column prop="createDate" label="创建时间" header-align="center" align="center" show-overflow-tooltip width="155"></el-table-column>

                    <el-table-column label="操作" align="center" show-overflow-tooltip width="110">
                        <template slot-scope="scope">
                            <el-button v-if="roleBtns.includes('version_edit')" title="编辑" type="text" size="mini" icon="el-icon-edit"
                                        @click="doClick(scope.row,'edit')"></el-button>
                            <el-button v-if="roleBtns.includes('version_view')" title="查看" type="text" size="mini" icon="el-icon-view"
                                        @click="doClick(scope.row,'view')"></el-button>
                            <el-button v-if="roleBtns.includes('version_delete')" title="删除" type="text" size="mini" icon="el-icon-delete"
                                        @click="doClick(scope.row,'delete')"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </transition>

        <!-- 底部分页 -->
        <div class="w-table-footer">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="tableObj.currentPage"
                           :page-sizes="tableObj.pageList"
                           :page-size="tableObj.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tableObj.total">
            </el-pagination>
        </div>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :close-on-click-modal="false">
            <!-- 弹窗组件 -->
            <addSystemVersion ref="dialogComponent"
                :mode="dialogObj.mode"
                :transObj="transObj"
                v-if="dialogObj.visible"
                @dialogClose="handleClose"
                @handle-success="handelSuccess"
            ></addSystemVersion>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center" v-if="dialogObj.mode !== 'view'">
                <el-button size="small" @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import {getPageVersionList,deleteVersionById} from 'api/system/sys.js'
    import addSystemVersion from './add_system_version_dialog'
    export default {
        components: {addSystemVersion},
        props : {},
        data() {
            return {
                transObj : {
                    id : ''
                },
                searchObj : {
                    title : '',
                    versionNum : '',
                },
                tableObj: {
                    loading: false,
                    tableH: 400,
                    tableData: [],
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageList: [10, 20, 50, 100] // 显示条数数组
                },

                btnLoading: false,
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '700px',
                    mode: 'add',
                },
            }
        },
        computed: {
            ...mapState('app', { clientSize: state => state.clientSize }),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        // 进入缓存页面触发
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        watch: {
            clientSize(val) {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            }
        },
        created() {
            //获取分页列表信息
            this.getTablePageList()
        },
        methods: {
            //点击事件
            doClick(obj, type){
                this.dialogObj.mode = type
                if (type === 'add') {
                    this.dialogObj.title = '新增版本';
                    this.dialogObj.visible = true;
                }else if(type === 'edit'){
                    this.transObj.id = obj.id
                    this.dialogObj.title = '编辑版本';
                    this.dialogObj.visible = true;
                }else if(type === 'view'){
                    this.transObj.id = obj.id
                    this.dialogObj.title = '查看版本';
                    this.dialogObj.visible = true;
                }else if(type === 'delete'){
                    this.delete(obj)
                }
            },
            //删除
            delete(obj){
                let that = this
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let param = { id: obj.id }
                    deleteVersionById(param).then(res => {
                        if (res.operationCode == 1) {
                            that.$message({ message: '删除成功', type: 'success' })
                            that.getTablePageList()
                        } else {
                            that.$message({ message: res.msg, type: 'error' })
                        }
                    })
                })
            },
            //列表搜索
            searchPageList(searchObj){
                this.searchObj = searchObj
                this.tableObj.currentPage = 1
                this.getTablePageList()
            },
            //获取列表信息
            getTablePageList(){
                let that = this
                let param = {}
                param.current = this.tableObj.currentPage
                param.size = this.tableObj.pageSize
                param.title = this.searchObj.title
                param.versionNum = this.searchObj.versionNum
                getPageVersionList(param).then(res => {
                    if (res.operationCode == 1) {
                        that.tableObj.tableData = res.data.records
                        that.tableObj.total = parseInt(res.data.total)
                    }
                });
            },

            // 切换显示条数
            handleSizeChange(val) {
                this.tableObj.pageSize = val
                this.getTablePageList()
            },

            // 切换当前页码
            handleCurrentChange(cur) {
                this.tableObj.currentPage = cur
                this.getTablePageList()
            },

            // 确定按钮事件
            doSave() {
                this.$refs.dialogComponent.doSave(this.deptId);
            },
            //成功回调事件
            handelSuccess(){
                this.dialogObj.visible = false;
                this.getTablePageList();
            },
            // 关闭弹窗事件
            handleClose() {
                this.dialogObj.visible = false;
            },
        }
    }
</script>
<style scoped>
</style>